export default "__VITE_ASSET__DlEQmjWb__"